import { adt, iots } from '@code-expert/prelude';

//Keep this file in syn with the clientPermissions in the api

export const ProjectReadPermission = iots.literal('project:read');
export type ProjectReadPermission = iots.TypeOf<typeof ProjectReadPermission>;

export const ProjectWritePermission = iots.literal('project:write');
export type ProjectWritePermission = iots.TypeOf<typeof ProjectWritePermission>;

export const UserReadPermission = iots.literal('user:read');
export type UserReadPermission = iots.TypeOf<typeof UserReadPermission>;
export const Permission = iots.union([
  ProjectReadPermission,
  ProjectWritePermission,
  UserReadPermission,
]);
export type Permission = iots.TypeOf<typeof Permission>;

// -------------------------------------------------------------------------------------------------

export const foldPermissions = adt.foldFromKeys<Permission>({
  'user:read': null,
  'project:read': null,
  'project:write': null,
});
